module.exports = __webpack_public_path__ + "static/img/RAT_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAT_1.png
// module id = u3Je
// module chunks = 0